module.exports = __webpack_public_path__ + "img/title1.12ba6cf0.png";